import PaymentRadio from 'components/FrictionlessCheckout/Payment/PaymentMethodList/PaymentRadio/PaymentRadio';
import { connect } from 'react-redux';
import { createStructuredSelector, createSelector } from 'reselect';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import FrameworkUtils from 'utils/framework';
import PaymentDetailsEN from 'components/FrictionlessCheckout/Payment/PaymentDetails/locales/PaymentDetails_en_US';
import PaymentDetailsFR from 'components/FrictionlessCheckout/Payment/PaymentDetails/locales/PaymentDetails_fr_CA';

const { wrapHOC } = FrameworkUtils;
const { getTextFromResource, getLocalisedDataFromResource } = LanguageLocaleUtils;
const getText = getLocalisedDataFromResource(PaymentDetailsEN, PaymentDetailsFR);

const localization = createStructuredSelector({
    paymentGiftCardMessage: getTextFromResource(getText, 'paymentGiftCardMessage', ['{0}'])
});

const fields = createSelector(localization, locales => {
    return {
        locales
    };
});

const withPaymentDisplayProps = wrapHOC(connect(fields, null));

export default withPaymentDisplayProps(PaymentRadio);
